import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "../lib/api";
import { toast } from "sonner";

export default function AdminLoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await auth.login(email, password);
      auth.saveToken(res.data.access_token);
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main data-testid="admin-login-page" className="min-h-screen flex items-center justify-center px-6 py-32 relative">
      <div className="absolute inset-0 opacity-30">
        <img src="https://static.prod-images.emergentagent.com/jobs/d067dda8-b284-4a23-bddb-a730a8ff782e/images/21f2c8009eedff903351081b04387eb7008ea7910e48e767e25e130c87a5b8f4.png" alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-b from-black via-black/70 to-black" />
      </div>
      <form onSubmit={submit} className="relative glass-dark p-10 md:p-12 w-full max-w-md">
        <div className="text-center mb-8">
          <p className="onyx-wordmark text-3xl">ONYX</p>
          <p className="eyebrow mt-2 text-white/50">— Administration</p>
        </div>
        <div className="space-y-5">
          <div>
            <label className="eyebrow block mb-2">Email</label>
            <input data-testid="admin-email" type="email" autoComplete="email" className="luxe-input" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </div>
          <div>
            <label className="eyebrow block mb-2">Password</label>
            <input data-testid="admin-password" type="password" autoComplete="current-password" className="luxe-input" value={password} onChange={(e) => setPassword(e.target.value)} required />
          </div>
          <button data-testid="admin-login-btn" type="submit" disabled={loading} className="btn-luxe btn-luxe-solid w-full mt-6">
            {loading ? "Signing in…" : "Enter Dashboard"}
          </button>
        </div>
      </form>
    </main>
  );
}
